import { DatePipe, ViewportScroller } from '@angular/common';
import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { BiTolFiltroService } from './bi-tol-filtro.service';
import { BiTolService } from './bi-tol.service';
import { FiltroDealers } from './filtro-dealer';

@Component({
  selector: 'app-bi-tol',
  templateUrl: './bi-tol.component.html',
  styleUrls: ['./bi-tol.component.scss']
})
export class BiTolComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;

  registros: any[] = [];
  registrosAnalitico: any[] = [];
  registrosBloqueados: any[] = [];

  columnsSynthetic: any[];
  _selectedColumnsSynthetic: any[];

  columnsAnalytical: any[];
  _selectedColumnsAnalytical: any[];

  columnsBloqueados: any[];
  _selectedColumnsBloqueados: any[];

  dataInicial: Date;
  dataFinal: Date;
  nomeModulo: string;
  nomeModuloAnalitico: string;
  nomeModuloBloqueados: string;
  textoComment: string = '';
  textoMessage: string = '';

  first: number = 0;
  displayRows: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  firstAn: number = 0;
  displayRowsAn: number = 0;
  rowsAn: number = 10;
  totalRecors: number = 0;

  maxDate: Date = new Date();

  filtrosDealers: FiltroDealers;

  displayFiltrosDealers: boolean = false;
  displayComentarios: boolean = false;
  displayMensagens: boolean = false;
  carregando: boolean = false;
  loading: boolean = false;
  filtrado: boolean = false;

  @ViewChild('dt') dt: Table;
  @ViewChildren('dealers') dealers: QueryList<ElementRef>;

  dadosTranslate = {
    'Dealers': 'businessIntelligence.tol.gridHeader.dealers',
    'Nome': 'businessIntelligence.tol.gridHeader.nome',
    'Interface': 'businessIntelligence.tol.gridHeader.interface',
    'Sucesso': 'businessIntelligence.tol.gridHeader.sucesso',
    'Erro': 'businessIntelligence.tol.gridHeader.erro',
    'Bloqueados': 'businessIntelligence.tol.gridHeader.bloqueados',
    'OS/Aberta': 'businessIntelligence.tol.gridHeader.osAberta',
    'OS/Aberta Dealer': 'businessIntelligence.tol.gridHeader.osAbertaDealer',
    'Envio/OS': 'Envio/OS',
    'chassi': 'businessIntelligence.tol.gridHeader.chassi',
    'quilometragem': 'businessIntelligence.tol.gridHeader.quilometragem',
    'comentários': 'businessIntelligence.tol.gridHeader.comentarios',
    'Mensagem': 'businessIntelligence.tol.gridHeader.mensagem',
    'tipoServico': 'businessIntelligence.tol.gridHeader.tipoServico',
    'dataFechamentoOs': 'businessIntelligence.tol.gridHeader.dataFechamentoOs'
  };

  constructor(
    private service: BiTolService,
    private translate: TranslateService,
    private servico: BiTolFiltroService,
    private exportExcelService: ExportExcelService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private date: DatePipe,
    private viewportScroller: ViewportScroller
  ) {
    this.filtros = {};
    this.nomeModulo = 'TOL - Sintético';
    this.nomeModuloAnalitico = 'TOL - Analítico';
    this.nomeModuloBloqueados = 'TOL - Bloqueados';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealer: [''],
      codigo: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.columnsSynthetic = [
      { field: 'dealerCode', header: 'businessIntelligence.tol.gridHeader.dealers' },
      { field: 'dealerName', header: 'businessIntelligence.tol.gridHeader.nome' },
      // { field: 'successQuantity', header: 'businessIntelligence.tol.gridHeader.sucesso' },
      { field: 'errorsQuantity', header: 'businessIntelligence.tol.gridHeader.erro' },
      { field: 'blockedQuantity', header: 'businessIntelligence.tol.gridHeader.bloqueados' },
      { field: 'pendingQuantity', header: 'businessIntelligence.tol.gridHeader.pendente' },
      { field: 'envioOs', header: 'Envio/OS' },
      { field: 'openOsQuantity', header: 'businessIntelligence.tol.gridHeader.osAberta' },
      { field: 'openOsDealerQuantity', header: 'businessIntelligence.tol.gridHeader.osAbertaDealer' }
    ];

    this.columnsAnalytical = [
      { field: 'dealerCode', header: 'businessIntelligence.tol.gridHeader.dealers' },
      { field: 'vin', header: 'businessIntelligence.tol.gridHeader.chassi' },
      { field: 'mileage', header: 'businessIntelligence.tol.gridHeader.quilometragem' },
      { field: 'description', header: 'businessIntelligence.tol.gridHeader.comentarios', width: '200px' },
      { field: 'message', header: 'businessIntelligence.tol.gridHeader.mensagem', width: '200px' },
      { field: 'serviceType', header: 'businessIntelligence.tol.gridHeader.tipoServico' },
      { field: 'osClosingDate', header: 'businessIntelligence.tol.gridHeader.dataFechamentoOs' }
      // { field: 'osClosingDate', header: 'businessIntelligence.tol.gridHeader.dataFechamentoOs', type: this.date, arg1: 'dd/MM/yyyy' },
    ];

    this.columnsBloqueados = [
      { field: 'dealerCode', header: 'businessIntelligence.tol.gridHeader.dealers' },
      { field: 'vin', header: 'businessIntelligence.tol.gridHeader.chassi' },
      { field: 'mileage', header: 'businessIntelligence.tol.gridHeader.quilometragem' },
      { field: 'description', header: 'businessIntelligence.tol.gridHeader.comentarios', width: '200px' },
      { field: 'message', header: 'businessIntelligence.tol.gridHeader.mensagem', width: '200px' },
      { field: 'serviceType', header: 'businessIntelligence.tol.gridHeader.tipoServico' },
      { field: 'osClosingDate', header: 'businessIntelligence.tol.gridHeader.dataFechamentoOs' }
    ];

    this._selectedColumnsSynthetic = this.columnsSynthetic;
    this._selectedColumnsAnalytical = this.columnsAnalytical;
    this._selectedColumnsBloqueados = this.columnsBloqueados;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumnsSynthetic(): any[] {
    return this._selectedColumnsSynthetic;
  }

  @Input() get selectedColumnsAnalytical(): any[] {
    return this._selectedColumnsAnalytical;
  }

  @Input() get selectedColumnsBloqueados(): any[] {
    return this._selectedColumnsBloqueados;
  }

  set selectedColumnsSynthetic(val: any[]) {
    this._selectedColumnsSynthetic = this.columnsSynthetic.filter(col => val.includes(col));
  }

  set selectedColumnsAnalytical(val: any[]) {
    this._selectedColumnsAnalytical = this.columnsAnalytical.filter(col => val.includes(col));
  }

  set selectedColumnsBloqueados(val: any[]) {
    this._selectedColumnsBloqueados = this.columnsBloqueados.filter(col => val.includes(col));
  }

  get f() {
    return this.form.controls;
  }

  private getAll() {
    this.loading = true;

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealer.value).subscribe(res => {
      this.registros = res.dados;

      this.registros.forEach(element => {
        if (element.blockedQuantity == null || element.blockedQuantity == undefined) {
          element.blockedQuantity = 0;
        }

        if (element.openOsQuantity == null || element.openOsQuantity == undefined) {
          element.openOsQuantity = 0;
        }

        element.openOsDealerQuantity = element.openOsDealerQuantity ?? element.osAbertaDealer ?? element.openOsDealer ?? element.os_aberta_dealer ?? 0;

        if (!element.envioOs) {
          element.envioOs = 'VERMELHO';
        }
      });

      this.loading = false;
      this.carregando = false;
    });
  }

  private getAllAnalitico() {
    this.loading = true;

    this.service.getDadosAnaliticos(this.f.codigo.value, this.f.data_inicial.value, this.f.data_final.value).subscribe(res => {
      this.registrosAnalitico = res.dados;

      this.registrosAnalitico.forEach(element => {
        element.osClosingDate = element.osClosingDate.substr(0, 10);

        if (element.message != null) {
          element.message = atob(element.message);
        }
      });

      this.loading = false;
    });

    if (!this.filtrado) {
      setTimeout(() => {
        this.viewportScroller.scrollToAnchor('target');
      }, 300);
    }
  }

  private getAllBloqueados() {
    this.loading = true;

    this.service.getDadosBloqueados(this.f.codigo.value, this.f.data_inicial.value, this.f.data_final.value).subscribe(res => {
      this.registrosBloqueados = res.dados;

      this.registrosBloqueados.forEach(element => {
        element.osClosingDate = element.osClosingDate.substr(0, 10);

        if (element.message != null) {
          element.message = atob(element.message);
        }
      });

      this.loading = false;
    });

    if (!this.filtrado) {
      setTimeout(() => {
        this.viewportScroller.scrollToAnchor('targetBloqueados');
      }, 300);
    }
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public abrirComentarios(index) {
    this.displayComentarios = true;
    this.textoComment = this.registrosAnalitico[index].description;
  }

  public abrirMensagens(index) {
    this.displayMensagens = true;
    this.textoMessage = this.registrosAnalitico[index].message;
  }

  public fecharComentarios() {
    this.displayComentarios = false;
    this.textoComment = '';
  }

  public fecharMensagens() {
    this.displayMensagens = false;
    this.textoMessage = '';
  }

  protected removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;

    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { chave: 'dealers', valor: [] };

      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });

      filtros.push(item);
    }
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    const firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.carregando = true;
    this.filtrado = true;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();

    if (this.registrosAnalitico.length != 0) {
      this.getAllAnalitico();
    }

    if (this.registrosBloqueados.length != 0) {
      this.getAllBloqueados();
    }
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealer.setValue(this.filtros.dealers[0]);
      this.registrosAnalitico.length = 0;
      this.registrosBloqueados.length = 0;
    } else {
      this.f.dealer.setValue('');
      this.registrosAnalitico.length = 0;
      this.registrosBloqueados.length = 0;
    }
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  public limparFiltros() {
    this.tratarData();

    if (this.filtros.dealers != undefined) {
      this.filtros.dealers.length = 0;
    }

    this.dealers.forEach(item => {
      const el: HTMLElement = item.nativeElement;
      el.click();
    });

    this.f.dealer.setValue('');
    this.f.codigo.setValue('');

    this.getAll();
    this.registrosAnalitico.length = 0;
    this.registrosBloqueados.length = 0;
  }

  private formatarEnvioOsExcel(envioOs: any): string {
    if (!envioOs) {
      return 'N/A';
    }

    const valor = envioOs.toString().trim().toUpperCase();

    if (valor === 'VERDE') {
      return 'OK';
    }

    if (valor === 'VERMELHO') {
      return 'N/A';
    }

    return 'N/A';
  }

  private getValorExportacaoSintetico(registro: any, field: string): any {
    if (field === 'envioOs') {
      return this.formatarEnvioOsExcel(registro[field]);
    }

    return this.translateField(registro[field]);
  }

  public exportExcel() {
    let registros = [];
    let registrosAnalitico = [];
    let registrosBloqueados = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealer.value).subscribe(res => {
      registros = res.dados;

      registros.forEach(element => {
        if (element.blockedQuantity == null || element.blockedQuantity == undefined) {
          element.blockedQuantity = 0;
        }

        if (element.openOsQuantity == null || element.openOsQuantity == undefined) {
          element.openOsQuantity = 0;
        }

        element.openOsDealerQuantity = element.openOsDealerQuantity ?? element.osAbertaDealer ?? element.openOsDealer ?? element.os_aberta_dealer ?? 0;

        if (!element.envioOs) {
          element.envioOs = 'VERMELHO';
        }
      });

      if (registros.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModulo;

        this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
          const linha = {};

          this._selectedColumnsSynthetic.forEach(c => {
            linha[this.translateHeader(c.header)] = this.getValorExportacaoSintetico(r, c.field);
          });

          return linha;
        }));
      }
    });

    if (this.registrosAnalitico.length != 0) {
      this.service.getDadosAnaliticos(this.f.codigo.value, this.f.data_inicial.value, this.f.data_final.value).subscribe(res => {
        registrosAnalitico = res.dados;

        registrosAnalitico.forEach(element => {
          element.osClosingDate = element.osClosingDate.substr(0, 10);

          if (this.translate.currentLang == 'br') {
            element.osClosingDate = moment(element.osClosingDate).format('DD/MM/YYYY');
          } else if (this.translate.currentLang == 'gb') {
            element.osClosingDate = moment(element.osClosingDate).format('YYYY/MM/DD');
          }
        });

        if (registrosAnalitico.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModuloAnalitico;

          this.exportExcelService.ExportTOExcelJSON(registrosAnalitico.map(r => {
            const linha = {};

            this._selectedColumnsAnalytical.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });
    }

    if (this.registrosBloqueados.length != 0) {
      this.service.getDadosBloqueados(this.f.codigo.value, this.f.data_inicial.value, this.f.data_final.value).subscribe(res => {
        registrosBloqueados = res.dados;

        registrosBloqueados.forEach(element => {
          element.osClosingDate = element.osClosingDate.substr(0, 10);

          if (this.translate.currentLang == 'br') {
            element.osClosingDate = moment(element.osClosingDate).format('DD/MM/YYYY');
          } else if (this.translate.currentLang == 'gb') {
            element.osClosingDate = moment(element.osClosingDate).format('YYYY/MM/DD');
          }
        });

        if (registrosBloqueados.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModuloBloqueados;

          this.exportExcelService.ExportTOExcelJSON(registrosBloqueados.map(r => {
            const linha = {};

            this._selectedColumnsBloqueados.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });
    }
  }

  protected translateHeader(item) {
    if (item == 'businessIntelligence.tol.gridHeader.dealers') {
      return 'Dealers';
    }

    if (item == 'businessIntelligence.tol.gridHeader.nome') {
      return this.translate.currentLang == 'br' ? 'Nome' : 'Name';
    }

    if (item == 'businessIntelligence.tol.gridHeader.interface') {
      return 'Interface';
    }

    if (item == 'businessIntelligence.tol.gridHeader.sucesso') {
      return this.translate.currentLang == 'br' ? 'Sucesso' : 'Success';
    }

    if (item == 'businessIntelligence.tol.gridHeader.erro') {
      return this.translate.currentLang == 'br' ? 'Erro' : 'Error';
    }

    if (item == 'businessIntelligence.tol.gridHeader.bloqueados') {
      return this.translate.currentLang == 'br' ? 'Bloqueados' : 'Blocked';
    }

    if (item == 'businessIntelligence.tol.gridHeader.pendente') {
      return this.translate.currentLang == 'br' ? 'Pendente' : 'Pending';
    }

    if (item == 'businessIntelligence.tol.gridHeader.osAberta') {
      return this.translate.currentLang == 'br' ? 'OS/Aberta' : 'S.O./Open';
    }

    if (item == 'businessIntelligence.tol.gridHeader.osAbertaDealer') {
      return this.translate.currentLang == 'br' ? 'OS/Aberta Dealer' : 'S.O./Open Dealer';
    }

    if (item == 'Envio/OS') {
      return 'Envio/OS';
    }

    if (item == 'businessIntelligence.tol.gridHeader.chassi') {
      return this.translate.currentLang == 'br' ? 'Chassi' : 'Chassis';
    }

    if (item == 'businessIntelligence.tol.gridHeader.quilometragem') {
      return this.translate.currentLang == 'br' ? 'Quilometragem' : 'Mileage';
    }

    if (item == 'businessIntelligence.tol.gridHeader.comentarios') {
      return this.translate.currentLang == 'br' ? 'Comentários' : 'Comments';
    }

    if (item == 'businessIntelligence.tol.gridHeader.mensagem') {
      return this.translate.currentLang == 'br' ? 'Mensagem' : 'Message';
    }

    if (item == 'businessIntelligence.tol.gridHeader.tipoServico') {
      return this.translate.currentLang == 'br' ? 'Tipo de Serviço' : 'Type of Service';
    }

    if (item == 'businessIntelligence.tol.gridHeader.dataFechamentoOs') {
      return this.translate.currentLang == 'br' ? 'Data de Fechamento O.S.' : 'Closing Date S.O.';
    }

    return item;
  }

  protected translateField(item) {
    return item;
  }

  protected getTranslate(value) {
    return this.dadosTranslate[value];
  }

  public getDealerCode(index) {
    this.filtrado = false;
    this.f.codigo.setValue(this.registros[index].dealerCode);

    if (this.registros[index].errorsQuantity != 0) {
      this.getAllAnalitico();
    } else {
      this.registrosAnalitico.length = 0;
    }
  }

  public getDealerCodeBloqueados(index) {
    this.filtrado = false;
    this.f.codigo.setValue(this.registros[index].dealerCode);

    if (this.registros[index].blockedQuantity != 0) {
      this.getAllBloqueados();
    } else {
      this.registrosBloqueados.length = 0;
    }
  }
}
